// import React, { useState, useEffect } from 'react';
// import { getIcons, userRole } from '../../Constant/Constant';
// import { useNavigate } from 'react-router-dom';

// const PropertiesSelectingModel = ({ isOpen, close, onSelect }) => {
//   const icons = getIcons();

//   const navigate = useNavigate()

//   const PropertyType = [
//     { label: "Layout", icon: icons.LayoutIcon },
//     { label: "Villa", icon: icons.villaIcon },
//     { label: "Apartment", icon: icons.ApartmentIcon },
//     { label: "Acres & Cents", icon: icons.AcresCentsIcon },
//   ];

//   const SaleTypes = ["Sale", "Resale", "Rent"];

//   const [selectedSaleType, setSelectedSaleType] = useState("");
//   const [selectedPropertyType, setSelectedPropertyType] = useState("");

//   useEffect(() => {
//     if (!isOpen) {
//       setSelectedSaleType("");
//       setSelectedPropertyType("");
//     }
//   }, [isOpen]);

//   const handleSubmit = () => {
//     if (selectedSaleType && selectedPropertyType) {
//         const path = userRole === "Admin" ? '/admin' : '/cmo'
//         navigate(`${path}/properties-manage`,{
//             state : {
//                 proprtyType : selectedPropertyType,
//                 proprtySaleType : selectedSaleType

//             }
//         })

//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 transition-opacity duration-300">
//       <div className="bg-white flex flex-col gap-6 rounded-lg p-6 w-full max-w-2xl relative animate-fade-in-up">
//         {/* Header */}
//         <div className="flex items-center justify-between bg-slate-100 px-3 py-4 rounded-md">
//           <div className="text-lg font-medium text-customGreen">
//             Select To Create Property
//           </div>
//           <button
//             onClick={close}
//             className="text-2xl bg-white rounded-full w-10 h-10 text-red-500"
//           >
//             &times;
//           </button>
//         </div>

//         {/* Sale Types */}
//         <div className="flex items-center gap-2">
//           {SaleTypes.map((type) => (
//             <button
//               key={type}
//               onClick={() => setSelectedSaleType(type)}
//               className={`rounded-full w-24 py-2 ${
//                 selectedSaleType === type
//                   ? 'bg-customGreen text-white'
//                   : 'bg-slate-100 text-slate-700'
//               }`}
//             >
//               {type}
//             </button>
//           ))}
//         </div>

//         {/* Property Types */}
//         <div className="grid grid-cols-1 gap-4 mt-4">
//   {PropertyType.map((item, index) => (
//     <div
//       key={index}
//       onClick={() => setSelectedPropertyType(item.label)}
//       className={`cursor-pointer rounded-full p-4 flex items-center gap-3 transition hover:text-customGreen ${
//         selectedPropertyType === item.label
//           ? 'border border-customGreen bg-green-50'
//           : 'bg-white'
//       }`}
//     >
//       <img src={item.icon} alt={item.label} className="w-7 h-7 object-contain" />
//       <div className="font-medium">{item.label}</div>
//     </div>
//   ))}
// </div>

//         {/* Confirm Button */}
//         <div className="flex justify-end mt-4">
//           <button
//             onClick={handleSubmit}
//             disabled={!selectedSaleType || !selectedPropertyType}
//             className={`px-6 py-2 rounded-md font-semibold transition ${
//               selectedSaleType && selectedPropertyType
//                 ? 'bg-customGreen text-white'
//                 : 'bg-gray-300 text-gray-500 cursor-not-allowed'
//             }`}
//           >
//             Create
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PropertiesSelectingModel;

import React, { useState, useEffect } from "react";
import { getIcons, userRole } from "../../Constant/Constant";
import { useNavigate } from "react-router-dom";
import { propertySaleTypes } from "../../../Enum";

const PropertiesSelectingModel = ({ isOpen, close, onSelect }) => {
  const icons = getIcons();
  const navigate = useNavigate();

  const PropertyType = [
    { label: "Layout", icon: icons.LayoutIcon  , id : "fOQZ4CPJQYZikZnFkrxy"},
    { label: "Villa", icon: icons.villaIcon , id : "k6QfCzo0QVXutC3MUTfV"},
    { label: "Apartment", icon: icons.ApartmentIcon , id : "xOl7nFLzvXtqVAcSrvIC"},
    // { label: "Acres & Cents", icon: icons.AcresCentsIcon , id : "h0n4k3gZ3rB45kJKPn" },
  ];



  const [selectedSaleType, setSelectedSaleType] = useState("");

  const [selectedPropertyType, setSelectedPropertyType] = useState("");
  const [selectedPropertyDetails, setSelectedPropertyDetails] = useState([]);

  useEffect(() => {
    if (!isOpen) {
      setSelectedSaleType("");
      setSelectedPropertyType("");
    }
  }, [isOpen]);

  const handlePropertyType = (item) => {
    setSelectedPropertyType(item.id);
    setSelectedPropertyDetails(item)
  };

  const handleSubmit = () => {
    const path = userRole === "Admin" ? "/admin" : "/cmo";
  
    if (!selectedSaleType || !selectedPropertyDetails.label) return;
  
    const type = selectedPropertyDetails.label;
  
    if (type === "Layout") {
      navigate(`${path}/layout-properties-manage`, {
        state: {
          selectedPropertyDetails,
          propertySaleType: selectedSaleType,
        },
      });
      return;
    }
  
    if (type === "Villa") {
      navigate(`${path}/villa-properties-manage`, {
        state: {
          selectedPropertyDetails,
          propertySaleType: selectedSaleType,
        },
      });
      return;
    }
  
    if (type === "Apartment") {
      navigate(`${path}/apartment-properties-manage`, {
        state: {
          selectedPropertyDetails,
          propertySaleType: selectedSaleType,
        },
      });
      return;
    }
  
  };
  
  

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 transition-opacity duration-300"
      onClick={(e) => e.target === e.currentTarget && close()}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div className="bg-white flex flex-col gap-6 rounded-lg p-5 w-full max-w-2xl relative animate-fade-in-up">
        {/* Header */}
        <div className="flex items-center justify-between bg-slate-50 px-4 py-2 rounded-lg">
          <h2
            id="modal-title"
            className="text-lg font-semibold text-customGreen"
          >
            Create New Property
          </h2>
          <button
            onClick={close}
            className="hover:text-gray-500 border bg-white p-2 text-red-500 transition-colors rounded-full w-9 h-9 flex items-center justify-center"
            aria-label="Close modal"
          >
            <svg
              xmlns="http://www.w3.org/XPath/2000/svg"
              className="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>

        {/* Sale Types */}
        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700">
            Select Sale Type
          </label>
          <div className="flex items-center gap-4">
            {propertySaleTypes.map((type, index) => (
              <label
                key={type}
                className={`flex items-center gap-2 px-4 py-2 rounded-full cursor-pointer transition-all
        ${
          selectedSaleType === type?.id
            ? " text-customGreen"
            : ""
        }`}
              >
                <input
                  type="radio"
                  name="saleType"
                  value={type?.id}
                  checked={selectedSaleType === type?.id}
                  onChange={() => setSelectedSaleType(type?.id)}
                  className="hidden"
                />
                <div
                  className={`w-5 h-5 rounded-full border-2 flex items-center justify-center
        ${selectedSaleType === type?.id ? "border-customGreen" : "border-slate-400"}`}
                >
                  {selectedSaleType === type?.id && (
                    <div className="w-3 h-3 bg-customGreen rounded-full" />
                  )}
                </div>
                <span className="text-sm font-medium">{type.label}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Property Types */}
        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700">
            Select Property Type
          </label>
          <div className="grid grid-cols-1 gap-3">
            {PropertyType.map((item, index) => (
              <button
                key={index}
                onClick={() => handlePropertyType(item)}
                className={`cursor-pointer rounded-full p-3 flex items-center gap-3 transition-all ${
                  selectedPropertyType === item.id
                    ? "border border-customGreen bg-green-50 shadow-sm"
                    : " bg-white hover:border-slate-300 hover:bg-slate-50"
                }`}
              >
                <div className="rounded-full p-2">
                  <img
                    src={item.icon}
                    alt={item.label}
                    className="w-6 h-6 object-contain"
                  />
                </div>
                <div className="font-medium">{item.label}</div>
              </button>
            ))}
          </div>
        </div>

        {/* Confirm Button */}
        <div className="flex justify-end ">
          <button
            onClick={handleSubmit}
            disabled={!selectedSaleType || !selectedPropertyType}
            className={`px-6 py-2 rounded-md font-semibold transition-all ${
              selectedSaleType && selectedPropertyType
                ? "bg-customGreen text-white hover:bg-green-700 shadow-md"
                : "bg-gray-200 text-gray-400 cursor-not-allowed"
            }`}
          >
            Create Property
          </button>
        </div>
      </div>
    </div>
  );
};

export default PropertiesSelectingModel;
